module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_iterators.js
// module id = 130
// module chunks = 1